import { Component } from '@angular/core';
import {
  BaseComponent
} from 'base-form';

@Component({
  selector: 'mfpc-radio-group',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss']
})
export class RadioGroupComponent extends BaseComponent {}
